import { Link, NavLink, useLocation } from "react-router-dom";
import { site } from "../data/content";
import Brand from "./Brand";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/projects", label: "Projects" },
  { to: "/about", label: "About" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  useEffect(() => setOpen(false), [loc.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl"
      style={{ backgroundColor: "rgba(244,243,240,0.82)", borderBottom: "1px solid var(--border-soft)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
          <img src="/logo.png" alt="REConsultX" className="h-8 w-8 object-contain" />
          <Brand size="md" />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm tracking-wide link-underline font-medium ${isActive ? "text-[var(--primary)]" : "text-[var(--text-secondary)]"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <a
          href={`mailto:${site.email}?subject=Enquiry%20via%20reconsultx.com`}
          data-testid="navbar-contact-cta"
          className="hidden md:inline-flex items-center text-sm px-5 py-2.5 transition-colors"
          style={{ backgroundColor: "var(--primary)", color: "var(--bg)" }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "var(--primary-hover)")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "var(--primary)")}
        >
          Get in touch
        </a>

        <button
          className="md:hidden p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t" style={{ borderColor: "var(--border-soft)" }}>
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                className="text-base text-[var(--text-primary)]"
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href={`mailto:${site.email}`}
              className="text-sm py-2.5 text-center"
              style={{ backgroundColor: "var(--primary)", color: "var(--bg)" }}
              data-testid="mobile-contact-cta"
            >
              Get in touch
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
